import React from 'react';
import { ArticleHeading2, ArticleParagraph2, IconArrowRight16 } from '@cian/ui-kit';

import { getPluralNoun } from './utils/getPluralNoun';

import styles from './styles.css';

export const FAQBlock: React.FC<{ name: string; questionsCount: number; onClick(): void }> = props => {
  return (
    <div className={styles['block']} onClick={props.onClick}>
      <div className={styles['text-content']}>
        <ArticleParagraph2>
          {props.questionsCount} {getPluralNoun(props.questionsCount, 'вопрос', 'вопроса', 'вопросов')}
        </ArticleParagraph2>
        <ArticleHeading2>{props.name}</ArticleHeading2>
      </div>
      <IconArrowRight16 />
    </div>
  );
};
